import { useState, useCallback } from 'react';
import { JobMatcherService, JobMatcherAPIError } from '../api';
import type { JobAnalysisState, JobAnalysisResponse } from '../types';

export const useJobAnalysis = () => {
  const [state, setState] = useState<JobAnalysisState>({
    isLoading: false,
    result: null,
    error: null,
  });

  const analyzeJob = useCallback(async (jobText: string): Promise<JobAnalysisResponse | null> => {
    setState(prev => ({
      ...prev,
      isLoading: true,
      error: null,
    }));

    try {
      const result = await JobMatcherService.analyzeJob(jobText);
      setState(prev => ({
        ...prev,
        isLoading: false,
        result,
        error: null,
      }));
      return result;
    } catch (error) {
      const errorMessage = error instanceof JobMatcherAPIError 
        ? error.message 
        : 'An unexpected error occurred';
      
      setState(prev => ({
        ...prev,
        isLoading: false,
        result: null,
        error: errorMessage,
      }));
      return null;
    }
  }, []);

  const clearResult = useCallback(() => {
    setState({
      isLoading: false,
      result: null,
      error: null,
    });
  }, []);

  return {
    ...state,
    analyzeJob,
    clearResult,
  };
};